import { useContext } from 'react';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import Button from '../../../../components/Button';
import CancelButton from '../../../../components/CancelButton';
import InputField from '../../../../components/InputField';
import LanguageField from '../../../../components/LanguageField';
import LocaleField from '../../../../components/LocaleField';
import { CountryCodeField, PhoneInputField } from '../../../../components/PhoneInputField';
import TimezoneField from '../../../../components/TimezoneField';
import LegalNameVerification from '../../../../components/LegalNameVerification';
import GeneralEditContext from './GeneralEditContext';
import {
    desktopCSS,
    legalNameVerifiedCSS,
    phoneNumberFieldCSS,
    saveCancelActionsCSS,
} from './generalEditCSS';

const GeneralEditDesktop = () => {
    const {
        countries,
        countryCode,
        countryCodeError,
        firstName,
        language,
        lastName,
        legalNameVerified,
        locale,
        onCancel,
        onCountryCodeChange,
        onFirstNameChange,
        onLanguageChange,
        onLastNameChange,
        onLegalNameVerifiedChange,
        onLocaleChange,
        onPhoneChange,
        onSave,
        onTimezoneChange,
        options,
        phone,
        phoneDisabled,
        phoneError,
        saveButtonDisabled,
        timezone,
        fieldLabels: {
            cancelLabel,
            countryCodeLabel,
            firstNameLabel,
            languageLabel,
            lastNameLabel,
            localeLabel,
            mobilePhoneLabel,
            saveLabel,
            timezoneLabel,
        },
    } = useContext(GeneralEditContext);

    const { languages, locales, timezones } = options;

    return (
        <div css={desktopCSS}>
            <InputField
                label={`${firstNameLabel}*`}
                onChange={onFirstNameChange}
                value={firstName}
            />
            <InputField label={`${lastNameLabel}*`} onChange={onLastNameChange} value={lastName} />
            <EmotionThemeProvider theme={{ selectFieldInputWidth: '16.667rem' }}>
                <div css={phoneNumberFieldCSS}>
                    <CountryCodeField
                        countries={countries}
                        label={countryCodeLabel}
                        value={countryCode}
                        onChange={onCountryCodeChange}
                        errorMessage={countryCodeError}
                    />
                    <PhoneInputField
                        label={mobilePhoneLabel}
                        value={phone}
                        onChange={onPhoneChange}
                        errorMessage={phoneError}
                        disabled={phoneDisabled}
                    />
                </div>
            </EmotionThemeProvider>
            <LanguageField
                label={languageLabel}
                languages={languages}
                onChange={onLanguageChange}
                value={language}
            />
            <LocaleField
                label={localeLabel}
                locales={locales}
                onChange={onLocaleChange}
                value={locale}
            />
            <TimezoneField
                label={timezoneLabel}
                onChange={onTimezoneChange}
                timezones={timezones}
                value={timezone}
            />
            <div css={legalNameVerifiedCSS}>
                <LegalNameVerification
                    legalNameVerified={legalNameVerified}
                    onChange={onLegalNameVerifiedChange}
                />
            </div>
            <div css={saveCancelActionsCSS}>
                <CancelButton label={cancelLabel} onClick={onCancel} />
                <Button disabled={saveButtonDisabled} onClick={onSave}>
                    {saveLabel}
                </Button>
            </div>
        </div>
    );
};

export default GeneralEditDesktop;
